import React, { useState, useEffect } from 'react';
const Swal = window.Swal;
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { normalizeIjin } from '../hooks/normalizeIjin';
import { isPendingUang } from '../utils/uangApproval';
import CardUangReadonly from './CardUangReadonly';
import CardCarousel from './CardCarousel';

const CardUangKonfirmasi = ({ item, onSetujuClick, isSelected, onToggle }) => {
  let parsedPayload = {};
  if (item.payload) {
    try {
      if (typeof item.payload === 'string') parsedPayload = JSON.parse(item.payload);
      else if (typeof item.payload === 'object') parsedPayload = item.payload;
    } catch (e) { }
  }

  const nominalValue = item.nominal || parsedPayload.nominal;
  const formattedNominal = nominalValue
    ? new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(nominalValue)
    : null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        padding: 25,
        marginBottom: 16,
        border: '1px solid #e0e0e0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        fontFamily: '"Segoe UI", "Roboto", sans-serif',
      }}
    >
      <div>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h4 style={{
              fontWeight: 600,
              fontSize: 16,
              margin: '0 0 6px 0',
              color: '#1a1a1a',
              letterSpacing: '0.3px'
            }}>
              {item.nama_karyawan || 'Nama Tidak Diketahui'}
            </h4>
          </div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 600, padding: '4px 8px', backgroundColor: '#f3f4f6', borderRadius: 8 }}>
              ID: {item.id || 'N/A'}
            </div>
            {/* Checkbox */}
            <div 
              onClick={(e) => { e.stopPropagation(); onToggle(item.id); }}
              style={{
                width: 24,
                height: 24,
                background: isSelected ? "#2563eb" : "#fff",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
                border: isSelected ? "none" : "2px solid #cbd5e1",
                cursor: "pointer",
                flexShrink: 0
              }}
            >
              {isSelected && (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              )}
            </div>
          </div>
        </div>

        {/* Informasi Pengajuan */}
        <div style={{
          backgroundColor: '#f9f9f9',
          borderRadius: 8,
          padding: 16,
          marginBottom: 16,
          borderLeft: '4px solid #1890ff'
        }}>
          <div style={{ display: 'flex', marginBottom: 8 }}>
            <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Kategori :</div>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff', textTransform: 'capitalize' }}>
              {item.absen_id?.replace('_', ' ')}
            </div>
          </div>

          {formattedNominal && (
            <div style={{ display: 'flex', marginBottom: 8 }}>
              <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Nominal :</div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff' }}>
                {formattedNominal}
              </div>
            </div>
          )}

          {(item.tenor > 1 || parsedPayload.tenor > 1) && (
            <div style={{ display: 'flex', marginBottom: 8 }}>
              <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Tenor :</div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff' }}>
                {item.tenor || parsedPayload.tenor} Bulan
              </div>
            </div>
          )}

          {(item.durasi || parsedPayload.durasi) && (
            <div style={{ display: 'flex', marginBottom: 8 }}>
              <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Durasi :</div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff' }}>
                {item.durasi || parsedPayload.durasi} Jam
              </div>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', marginBottom: 8 }}>
          <div style={{ fontSize: 14 }}>Keterangan :</div>
        </div>
        <div style={{ display: 'flex', marginBottom: 16 }}>
          <div style={{ fontWeight: 500, fontSize: 14, color: '#1a1a1a' }}>{item.nama || '-'}</div>
        </div>

        {/* Tanda Tangan */}
        <div style={{
          display: 'flex',
          marginBottom: 16,
          paddingTop: 16,
          borderTop: '1px solid #f0f0f0',
        }}>
          {/* TTD Pemohon */}
          <div style={{ textAlign: 'center', flex: 1 }}>
            <p style={{
              fontSize: 13,
              color: '#595959',
              marginBottom: 8,
              fontWeight: 500
            }}>
              Cilacap, {new Date(item.created_at || new Date()).toLocaleDateString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}{' '}
              ({new Date(item.created_at || new Date()).toLocaleTimeString('id-ID', {
                hour: '2-digit',
                minute: '2-digit',
              })})
            </p>
            {item.ttd_pemohon ? (
              <img
                src={item.ttd_pemohon}
                alt="Tanda tangan pemohon"
                style={{
                  width: 140,
                  height: 80,
                  objectFit: 'contain',
                  border: 'none',
                  borderRadius: 6,
                  backgroundColor: '#fff',
                }}
              />
            ) : (
              <div style={{
                width: 140,
                height: 80,
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                backgroundColor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#bfbfbf',
                fontSize: 11,
                margin: '0 auto'
              }}>
                Belum tersedia
              </div>
            )}
          </div>
        </div>

        {/* Tombol Persetujuan */}
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <motion.button
            type="button"
            whileHover={{ scale: 1.01, backgroundColor: '#e6f7ff' }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onSetujuClick(item)}
            style={{
              width: '100%',
              maxWidth: 480,
              height: 64,
              border: item.status === 'DISETUJUI' ? '1px solid #1890ff' : '1px solid #d9d9d9',
              borderRadius: 10,
              backgroundColor: item.status === 'DISETUJUI' ? '#e6f7ff' : '#fafafa',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 16px',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div style={{ fontSize: 22, flexShrink: 0, color: '#1890ff' }}>
              {item.status === 'DISETUJUI' ? '✅' : '✍️'}
            </div>
            <div style={{ flex: 1, textAlign: 'left', marginLeft: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1890ff', lineHeight: 1.3 }}>
                {item.status === 'DISETUJUI' ? 'Pengajuan Telah Disetujui' : 'Beri Persetujuan'}
              </div>
              <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2 }}>
                {item.status === 'DISETUJUI'
                  ? `Disetujui pada ${item.tanggal_persetujuan ? new Date(item.tanggal_persetujuan).toLocaleDateString('id-ID') : new Date().toLocaleDateString('id-ID')}`
                  : 'Klik untuk melakukan verifikasi'}
              </div>
            </div>
            <div style={{ fontSize: 18, color: '#94a3b8', marginLeft: 12 }}>›</div>

            {item.status !== 'DISETUJUI' && (
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: 0,
                height: 0,
                borderTop: '14px solid #1890ff',
                borderLeft: '14px solid transparent',
              }} />
            )}
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

// Komponen Halaman Persetujuan
const HalamanPersetujuan = ({ item, onClose, onKonfirmasi, onUpdateItem }) => {
  const [alasan, setAlasan] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSendingNote, setIsSendingNote] = useState(false); // State for note sending

  // -- Periode Helpers --
  const getPeriod = () => {
    const now = new Date();
    let month = now.getMonth();
    const year = now.getFullYear();
    if (now.getDate() >= 21) {
      month += 1;
      if (month > 11) {
        month = 0;
        return `${new Date(year + 1, month).toLocaleString('en-US', { month: 'long' })} ${year + 1}`;
      }
    }
    return `${new Date(year, month).toLocaleString('en-US', { month: 'long' })} ${year}`;
  };

  const getAvailablePeriods = () => {
    const periods = new Set();
    const dateNow = new Date();

    // Base month following 21st cutoff logic
    let baseMonth = dateNow.getMonth();
    let baseYear = dateNow.getFullYear();
    if (dateNow.getDate() >= 21) baseMonth += 1;

    // Generate Range: Mundur 2 Bulan & Maju 2 Bulan
    for (let i = -2; i <= 2; i++) {
      const d = new Date(baseYear, baseMonth + i, 1);
      const label = `${d.toLocaleString('en-US', { month: 'long' })} ${d.getFullYear()}`;
      periods.add(label);
    }

    // Sort descending by date
    return Array.from(periods).sort((a, b) => new Date(b) - new Date(a));
  };

  const periodOptions = getAvailablePeriods();

  // Editable fields state
  const [editableNominal, setEditableNominal] = useState(item.nominal || '');
  const [editableTenor, setEditableTenor] = useState(item.tenor || item.durasi || '');
  const [editablePeriode, setEditablePeriode] = useState(item.periode || periodOptions[0] || '');

  let currentRole = 'hc'; // Default Keuangan
  if (item.absen_id === 'kasbon' || item.absen_id === 'cicilan') {
    if (!item.ttd_hc) currentRole = 'hc';
    else if (!item.ttd_direksi) currentRole = 'direksi';
  } else {
    // Lembur / Piket
    const dataKaryawan = JSON.parse(localStorage.getItem('data_karyawan') || '{}');
    const dept = (item.departement || dataKaryawan.departement || '').toString().toLowerCase();
    const level = (item.level || dataKaryawan.level || '').toString().toLowerCase();
    if (dept === 'operasional' && level === 'koordinator') {
      if (!item.ttd_kacab) currentRole = 'spv';
      else currentRole = 'hc';
    } else {
      currentRole = 'hc';
    }
  }

  // Extract history for this role
  let noteContent = '-';
  let tanggapanContent = '-';
  try {
    let parsedNotes = {};
    if (typeof item.catatan === 'string') {
      parsedNotes = JSON.parse(item.catatan);
    } else if (typeof item.catatan === 'object' && item.catatan !== null) {
      parsedNotes = item.catatan;
    }
    noteContent = parsedNotes[`catatan_${currentRole}`] || '-';
    tanggapanContent = parsedNotes[`tanggapan_untuk_${currentRole}`] || '-';
    console.log('parsedNotes', item.catatan);

  } catch (e) {
    console.warn('Error parsing notes', e);
  }


  // -- Update Catatan Logic --
  const handleUpdateCatatan = async () => {
    if (!alasan.trim()) {
      alert('Mohon isi catatan terlebih dahulu');
      return;
    }

    setIsSendingNote(true);
    try {
      // 1. Determine Role untuk payload
      let role = currentRole;

      // 2. Prepare Payload
      // Merge with existing notes
      let existingNotes = {};
      try {
        if (typeof item.catatan === 'string') existingNotes = JSON.parse(item.catatan);
        else if (typeof item.catatan === 'object' && item.catatan) existingNotes = item.catatan;
      } catch (err) { }

      const newNoteObject = {
        text: alasan,
        timestamp: new Date().toISOString()
      };

      const CatatanJson = JSON.stringify({
        ...existingNotes,
        [`catatan_${role}`]: newNoteObject
      });

      const bodyPayload = {
        id: item.id,
        catatan: CatatanJson,
        role: role
      };

      // 3. Call API
      // Using a hypothetical endpoint for updating only notes. 
      // If backend doesn't support this specific endpoint, we might need to adjust.
      const response = await fetch('https://jne-cilacap.com/slip/public/api/update_catatan_izin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(bodyPayload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Gagal mengirim catatan');
      }

      alert('Pesan berhasil dikirim/disimpan!');

      const updatedItem = {
        ...item,
        catatan: JSON.parse(CatatanJson)
      };

      if (onUpdateItem) {
        onUpdateItem(updatedItem);
      }

    } catch (error) {
      console.error('Error update_catatan_izin:', error);
      alert('Gagal mengirim pesan: ' + error.message);
    } finally {
      setIsSendingNote(false);
    }
  };

  // -- Signature Canvas Logic --
  const canvasRef = React.useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  // Setup canvas size on mount
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      // Set resolution higher for smoother lines
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    }
  }, []);

  const getCoordinates = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / (rect.width * (window.devicePixelRatio || 1));
    const scaleY = canvas.height / (rect.height * (window.devicePixelRatio || 1));

    let clientX, clientY;

    if (event.touches && event.touches.length > 0) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }

    return {
      x: (clientX - rect.left), // * scaleX if needed, but managing with scale() usually better
      y: (clientY - rect.top)
    };
  };

  const startDrawing = (e) => {
    // e.preventDefault(); // Prevent scrolling on touch
    setIsDrawing(true);
    const { x, y } = getCoordinates(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  };

  const draw = (e) => {
    if (!isDrawing) return;
    // e.preventDefault();
    const { x, y } = getCoordinates(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!hasSignature) setHasSignature(true);
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width / (window.devicePixelRatio || 1), canvas.height / (window.devicePixelRatio || 1));
    setHasSignature(false);
  };

  const handleSubmit = (status) => {
    // if (status === 'disetujui' && !hasSignature) {
    //   alert('Mohon tanda tangan terlebih dahulu');
    //   return;
    // }

    setIsSubmitting(true);
    let signatureData = null;
    if (hasSignature && canvasRef.current) {
      signatureData = canvasRef.current.toDataURL();
    }

    // Simulasi proses
    setTimeout(() => {
      onKonfirmasi(item.id, status, alasan, signatureData, editableNominal, editableTenor, editablePeriode);
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <motion.div
      initial={{ x: '100%' }}
      animate={{ x: 0 }}
      exit={{ x: '100%' }}
      transition={{ type: 'spring', damping: 25 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ffffff',
        zIndex: 1000,
        overflowY: 'auto',
        padding: 24,
        fontFamily: '"Segoe UI", "Roboto", sans-serif',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
        <motion.div
          onClick={onClose}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          style={{
            position: 'absolute',
            top: 15,
            left: 15,
            height: 24,
            width: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: '#fff',
            borderRadius: 20,
            padding: 8,
            marginTop: -3,
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            zIndex: 10,
          }}
        >
          <ArrowLeft size={22} color="#333" />
        </motion.div>
        <div>
          <h2 style={{
            margin: 0,
            marginTop: -8,
            marginLeft: 45,
            fontWeight: 600,
            fontSize: 18, // Ukuran diperkecil
            color: '#1a1a1a',
            letterSpacing: '0.3px'
          }}>
            Verifikasi Pengajuan {((item.absen_id || '').charAt(0).toUpperCase() + (item.absen_id || '').slice(1)).replace('_', ' ')}
          </h2>
          <p style={{ margin: '4px 0 0 45px', color: '#8c8c8c', fontSize: 14 }}>
            ID: {item.id} • {item.nama_karyawan}
          </p>
        </div>
      </div>

      {/* Detail Pengajuan */}
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        {/* Kartu Informasi */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          style={{
            backgroundColor: '#fafafa',
            borderRadius: 12,
            padding: 24,
            marginBottom: 32,
            border: '1px solid #f0f0f0',
          }}
        >
          <h3 style={{
            margin: '0 0 20px 0',
            fontWeight: 600,
            fontSize: 16,
            color: '#1a1a1a',
            paddingBottom: 12,
            borderBottom: '1px solid #e8e8e8'
          }}>
            Rincian Pengajuan
          </h3>

          <div style={{ display: 'grid', gap: 10 }}>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Nama :</div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{item.nama_karyawan}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Keterangan</div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{item.nama}</div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Nominal :</div>
              <div style={{ flex: 1 }}>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
                  <span style={{ position: 'absolute', left: 10, fontSize: 14, color: '#595959', fontWeight: 600 }}>Rp</span>
                  <input
                    type="number"
                    value={editableNominal}
                    onChange={(e) => setEditableNominal(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 12px 8px 35px',
                      border: '1px solid #d9d9d9',
                      borderRadius: 6,
                      fontSize: 14,
                      fontWeight: 600,
                      color: '#1890ff',
                      backgroundColor: '#fff',
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box',
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#1890ff'}
                    onBlur={(e) => e.target.style.borderColor = '#d9d9d9'}
                  />
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>
                {item.absen_id === 'lembur' ? 'Durasi (Jam) :' : 'Tenor (Bulan) :'}
              </div>
              <div style={{ flex: 1 }}>
                <input
                  type="number"
                  value={editableTenor}
                  onChange={(e) => setEditableTenor(e.target.value)}
                  style={{
                    width: '100%', // Mengikuti lebar card
                    padding: '8px 12px',
                    border: '1px solid #d9d9d9',
                    borderRadius: 6,
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#1890ff',
                    backgroundColor: '#fff',
                    outline: 'none',
                    transition: 'border-color 0.3s',
                    boxSizing: 'border-box',
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#1890ff'}
                  onBlur={(e) => e.target.style.borderColor = '#d9d9d9'}
                />
              </div>
            </div>

            {/* Periode Select */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Periode :</div>
              <div style={{ flex: 1 }}>
                <select
                  value={editablePeriode}
                  onChange={(e) => setEditablePeriode(e.target.value)}
                  style={{
                    width: '100%', // Mengikuti lebar card
                    padding: '10px 12px',
                    border: '1px solid #d9d9d9',
                    borderRadius: 8,
                    fontSize: 14,
                    fontWeight: 500,
                    backgroundColor: '#fff',
                    outline: 'none',
                    appearance: 'none',
                    backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '16px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    boxSizing: 'border-box',
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#1890ff';
                    e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d9d9d9';
                    e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                  }}
                >
                  {periodOptions.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                  {!periodOptions.includes(editablePeriode) && editablePeriode && (
                    <option value={editablePeriode}>{editablePeriode}</option>
                  )}
                </select>
              </div>
            </div>

            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Pengajuan:</div>
              <div style={{ fontSize: 14, color: '#8c8c8c' }}>
                {new Date(item.created_at).toLocaleString('id-ID', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Form Persetujuan */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 12,
            padding: 24,
            border: '1px solid #f0f0f0',
            boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
            marginTop: 32
          }}
        >
          <h3 style={{
            margin: '0 0 20px 0',
            fontWeight: 600,
            fontSize: 16,
            color: '#1a1a1a'
          }}>
            Form Persetujuan
          </h3>

          <div style={{ marginBottom: 24 }}>
            <label style={{
              display: 'block',
              marginBottom: 8,
              fontWeight: 500,
              fontSize: 14,
              color: '#595959'
            }}>
              Catatan / Alasan (Opsional)
            </label>

            {/* Conversation History Display */}
            {(() => {
              // Parse & Sort logic inline
              let parsedNotes = {};
              try {
                if (typeof item.catatan === 'string') parsedNotes = JSON.parse(item.catatan);
                else if (typeof item.catatan === 'object' && item.catatan) parsedNotes = item.catatan;
              } catch (e) { }

              const rawNote = parsedNotes[`catatan_${currentRole}`];
              const rawTanggapan = parsedNotes[`tanggapan_untuk_${currentRole}`];

              const messages = [];
              const addMsg = (content, type) => {
                if (!content || content === '-') return;
                let text = typeof content === 'object' ? content.text : content;
                let time = typeof content === 'object' ? content.timestamp : '1970-01-01T00:00:00.000Z';
                if (text && text !== '-') messages.push({ type, text, time });
              };
              addMsg(rawNote, 'note');
              addMsg(rawTanggapan, 'tanggapan');
              messages.sort((a, b) => new Date(a.time) - new Date(b.time));

              if (messages.length === 0) return null;

              return (
                <div style={{
                  marginBottom: 12,
                  padding: 12,
                  backgroundColor: '#fafafa',
                  border: '1px solid #f0f0f0',
                  borderRadius: 8,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8
                }}>
                  <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4 }}>Riwayat Percakapan:</div>

                  {messages.map((msg, idx) => {
                    const isNote = msg.type === 'note';
                    const align = isNote ? 'flex-end' : 'flex-start';

                    return (
                      <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: align }}>
                        <div style={{
                          backgroundColor: isNote ? '#f5f5f5' : '#e6f7ff',
                          border: `1px solid ${isNote ? '#d9d9d9' : '#91d5ff'}`,
                          color: isNote ? '#595959' : '#0050b3',
                          padding: '8px 12px',
                          borderRadius: isNote ? '12px 12px 0 12px' : '12px 12px 12px 0',
                          maxWidth: '90%',
                          fontSize: 13
                        }}>
                          <div style={{
                            fontSize: 10,
                            fontWeight: 700,
                            marginBottom: 2,
                            color: isNote ? '#8c8c8c' : '#1890ff',
                            textAlign: isNote ? 'right' : 'left',
                            display: 'flex',
                            justifyContent: isNote ? 'flex-end' : 'flex-start',
                            alignItems: 'center',
                            gap: 6
                          }}>
                            <span>{isNote ? 'Catatan Anda' : 'Pesan dari Pengajuan'}</span>
                            {msg.time !== '1970-01-01T00:00:00.000Z' && (
                              <span style={{ fontWeight: 400, opacity: 0.7 }}>
                                {new Date(msg.time).toLocaleString('id-ID', { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' })}
                              </span>
                            )}
                          </div>
                          {msg.text}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}

            <textarea
              value={alasan}
              onChange={(e) => setAlasan(e.target.value)}
              placeholder="Tambahkan catatan atau alasan persetujuan/penolakan..."
              style={{
                width: '100%',
                minHeight: 100,
                padding: 12,
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                fontSize: 14,
                resize: 'vertical',
                fontFamily: 'inherit',
                boxSizing: 'border-box',
                marginBottom: 8
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
              <button
                type="button"
                onClick={handleUpdateCatatan}
                disabled={isSendingNote || !alasan.trim()}
                style={{
                  backgroundColor: isSendingNote ? '#9ca3af' : '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '6px 12px',
                  fontSize: 12,
                  fontWeight: 500,
                  borderRadius: 6,
                  cursor: isSendingNote ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }}
              >
                {isSendingNote ? 'Mengirim...' : 'Kirim Pesan'} <div style={{ fontSize: 10 }}>➤</div>
              </button>
            </div>
          </div>

          {/* Tanda Tangan Digital */}
          <div style={{ marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <label style={{
                fontWeight: 500,
                fontSize: 14,
                color: '#595959'
              }}>
                Tanda Tangan Digital
              </label>
              <button
                onClick={clearSignature}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#ff4d4f',
                  fontSize: 13,
                  cursor: 'pointer',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }}
              >
                🗑️ Hapus
              </button>
            </div>

            <div style={{
              border: '2px dashed #d9d9d9',
              borderRadius: 8,
              overflow: 'hidden',
              backgroundColor: '#fafafa',
              position: 'relative',
              touchAction: 'none' // Penting untuk touch device
            }}>
              <canvas
                ref={canvasRef}
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onMouseLeave={stopDrawing}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
                style={{
                  width: '100%',
                  height: 200,
                  display: 'block',
                  cursor: 'crosshair',
                }}
              />
              {!hasSignature && (
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  pointerEvents: 'none',
                  color: '#bfbfbf',
                  fontSize: 14,
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: 24, marginBottom: 8 }}>✍️</div>
                  Silakan tanda tangan di sini
                </div>
              )}
            </div>
          </div>

          {/* Tombol Aksi */}
          <div style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'flex-end',
            paddingTop: 24,
            borderTop: '1px solid #f0f0f0'
          }}>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSubmit('ditolak')}
              disabled={isSubmitting}
              style={{
                padding: '12px 28px',
                borderRadius: 6,
                border: '1px solid #ff4d4f',
                backgroundColor: '#fff',
                color: '#ff4d4f',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: 120,
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? 'Memproses...' : 'Tolak Pengajuan'}
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSubmit('disetujui')}
              disabled={isSubmitting}
              style={{
                padding: '12px 28px',
                borderRadius: 6,
                border: 'none',
                backgroundColor: '#1890ff',
                color: '#fff',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: 120,
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? 'Memproses...' : 'Setujui Pengajuan'}
            </motion.button>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

const CardListUangKonfirmasi = () => {
  const [uangList, setUangList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    try {
      const data = localStorage.getItem('uang_konfirmasiPotongan');
      if (data) {
        const parsed = JSON.parse(data);
        const list = Array.isArray(parsed) ? parsed : (parsed && typeof parsed === 'object' ? [parsed] : []);

        const normalized = list.map(item => {
          const baseItem = normalizeIjin(item);
          if (baseItem.potongan_id) {
            if (baseItem.potongan_id === 3) baseItem.absen_id = 'kasbon';
            else if (baseItem.potongan_id === 22) baseItem.absen_id = 'lembur';
            else if (baseItem.potongan_id === 11) baseItem.absen_id = 'piket_harian';
            else baseItem.absen_id = 'cicilan';

            baseItem.nama = baseItem.keperluan || baseItem.nama || '-';
          }
          return baseItem;
        });

        setUangList(normalized.filter(isPendingUang));
      }
    } catch (error) {
      console.error('Error reading uang_konfirmasiPotongan:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleKonfirmasi = async (id, status, alasan, signatureData, updatedNominal, updatedTenor, updatedPeriode) => {
    const item = uangList.find(x => x.id === id);
    if (!item) return;

    const dataKaryawan = JSON.parse(localStorage.getItem('data_karyawan') || '{}');
    let role = 'hc';
    if (item.absen_id === 'kasbon' || item.absen_id === 'cicilan') {
      if (!item.ttd_hc) role = 'hc';
      else if (!item.ttd_direksi) role = 'direksi';
    } else {
      const dept = (item.departement || dataKaryawan.departement || '').toString().toLowerCase();
      const level = (item.level || dataKaryawan.level || '').toString().toLowerCase();
      if (dept === 'operasional' && level === 'koordinator') {
        if (!item.ttd_kacab) role = 'spv';
        else role = 'hc';
      } else {
        role = 'hc';
      }
    }

    const simStatusLocal = status === 'disetujui' ? 'DISETUJUI' : 'DITOLAK'; // untuk UI & localStorage
    const apiStatus = status === 'disetujui' ? 2 : 3; // untuk backend: 2=disetujui, 3=ditolak

    // Payload sesuai validasi backend (approve_potongan):
    // id (required), ttd_hc (required), status (required), jenis (required), approval_id (required)
    const bodyPayload = {
      id: id,
      ttd_hc: signatureData || 'signed_placeholder', // backend require ttd_hc
      status: apiStatus,
      jenis: item.absen_id?.startsWith('piket') ? 'piket' : item.absen_id,
      approval_id: dataKaryawan.id, // ID pengguna yang menyetujui
      nominal: updatedNominal,
      tenor: updatedTenor,
      periode: updatedPeriode,
    };

    console.log('Sending API Payload approve_potongan:', bodyPayload);

    // Helper: hapus item dari list & localStorage setelah diproses
    const removeFromLocal = () => {
      const updatedList = uangList.filter(u => u.id !== id);
      setUangList(updatedList);
      localStorage.setItem('uang_konfirmasiPotongan', JSON.stringify(updatedList));
      setSelectedItem(null);
      window.dispatchEvent(new Event('badgeUpdate'));
    };

    // Kirim ke backend
    try {
      const response = await fetch('https://jne-cilacap.com/slip/public/api/approve_potongan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(bodyPayload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Gagal memproses pengajuan');
      }

      console.log('API Response approve_potongan:', data);

      removeFromLocal();
      await Swal.fire({
        icon: status === 'disetujui' ? 'success' : 'info',
        title: status === 'disetujui' ? 'Disetujui!' : 'Ditolak!',
        text: `Pengajuan berhasil ${status === 'disetujui' ? 'disetujui' : 'ditolak'}.`,
        confirmButtonColor: status === 'disetujui' ? '#1890ff' : '#ff4d4f',
        confirmButtonText: 'OK',
        timer: 2500,
        timerProgressBar: true,
      });

    } catch (error) {
      console.error('Error approve_potongan:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Gagal!',
        text: 'Terjadi kesalahan saat mengirim data: ' + error.message,
        confirmButtonColor: '#ff4d4f',
        confirmButtonText: 'Tutup',
      });
    }
  };


  const toggleSelectAll = () => {
    if (selectedIds.length === uangList.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(uangList.map(i => i.id));
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleBulkKonfirmasiUang = async (statusDecision) => {
    if (selectedIds.length === 0) return;

    const dataKaryawan = JSON.parse(localStorage.getItem('data_karyawan') || '{}');
    const apiStatus = statusDecision === 'disetujui' ? 2 : 3;
    const itemsToProcess = uangList.filter(u => selectedIds.includes(u.id));

    Swal.fire({
      title: 'Memproses...',
      text: `Memproses 0 / ${itemsToProcess.length}`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const sleep = (ms) => new Promise(res => setTimeout(res, ms));

    const successIds = [];

    try {
      // Kirim satu per satu secara sequential dengan jeda 400ms
      // agar tidak kena rate limit 429 dari server
      for (let i = 0; i < itemsToProcess.length; i++) {
        const item = itemsToProcess[i];

        Swal.update({ text: `Memproses ${i + 1} / ${itemsToProcess.length}` });

        const payload = {
          id: item.id,
          ttd_hc: 'signed_placeholder',
          status: apiStatus,
          jenis: item.absen_id?.startsWith('piket') ? 'piket' : item.absen_id,
          approval_id: dataKaryawan.id,
          nominal: item.nominal,
          tenor: item.tenor,
          periode: item.periode,
        };

        try {
          const res = await fetch('https://jne-cilacap.com/slip/public/api/approve_potongan', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (res.ok) {
            successIds.push(item.id);
          } else {
            console.warn(`Gagal proses ID ${item.id}, status: ${res.status}`);
          }
        } catch (err) {
          console.error(`Error proses ID ${item.id}:`, err);
        }

        // Jeda antar request agar tidak kena rate limit (429)
        if (i < itemsToProcess.length - 1) await sleep(400);
      }

      if (successIds.length > 0) {
        const remainingList = uangList.filter(u => !successIds.includes(u.id));
        setUangList(remainingList);
        localStorage.setItem('uang_konfirmasiPotongan', JSON.stringify(remainingList));
      }

      setSelectedIds([]);

      const failedCount = itemsToProcess.length - successIds.length;
      Swal.fire({
        icon: successIds.length === itemsToProcess.length ? 'success' : (successIds.length > 0 ? 'warning' : 'error'),
        title: 'Selesai',
        text: failedCount === 0
          ? `Berhasil memproses ${successIds.length} pengajuan.`
          : `${successIds.length} berhasil, ${failedCount} gagal diproses.`,
        confirmButtonColor: '#4f7cff',
        confirmButtonText: 'OK',
      });

    } catch (error) {
      console.error('Bulk Approve Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Terjadi Kesalahan',
        text: 'Gagal memproses persetujuan masal.'
      });
    }
  };

  if (loading) {
    return (
      <div style={{
        textAlign: 'center',
        color: '#595959',
        marginTop: 60,
        fontSize: 15
      }}>
        Memuat data pengajuan keuangan...
      </div>
    );
  }

  if (uangList.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 24,
          width: '100%',
          maxWidth: 450,
          margin: '0 auto 24px auto',
          padding: '24px 20px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
          border: '1px solid #cbd5e1',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          textAlign: 'center',
          marginBottom: 32,
          paddingBottom: 24,
          borderBottom: '1px solid #f0f0f0'
        }}>
          <h2 style={{
            fontWeight: 700,
            fontSize: 18,
            margin: '0 0 2px 0',
            color: '#111827'
          }}>
            Konfirmasi Keuangan
          </h2>
          <p style={{ margin: 0, color: '#9ca3af', fontSize: 13 }}>
            {uangList.length} pengajuan keuangan menunggu persetujuan
          </p>
        </div>
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          background: '#f9fafb',
          borderRadius: 16,
          border: '1px dashed #e5e7eb'
        }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
          <p style={{ margin: 0, fontWeight: 600, color: '#4b5563', fontSize: 15 }}>
            Tidak Ada Pengajuan
          </p>
          <p style={{ margin: '4px 0 0 0', color: '#9ca3af', fontSize: 13 }}>
            Semua pengajuan keuangan telah diproses.
          </p>
        </div>
      </motion.div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <AnimatePresence>
        {selectedItem ? (
          <HalamanPersetujuan
            item={selectedItem}
            onClose={() => setSelectedItem(null)}
            onKonfirmasi={handleKonfirmasi}
            onUpdateItem={(id, updates) => {
              const updatedList = uangList.map(u => u.id === id ? { ...u, ...updates } : u);
              setUangList(updatedList);
              localStorage.setItem('uang_konfirmasiPotongan', JSON.stringify(updatedList));
            }}
          />
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              backgroundColor: '#ffffff',
              borderRadius: 24,
              width: '100%',
              maxWidth: 450,
              margin: '0 auto 24px auto',
              padding: '24px 20px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
              border: '1px solid #cbd5e1',
              boxSizing: 'border-box'
            }}
          >
            <div style={{
              textAlign: 'center',
              marginBottom: 32,
              paddingBottom: 24,
              borderBottom: '1px solid #f0f0f0'
            }}>
              <h2 style={{
                fontWeight: 700,
                fontSize: 18,
                margin: '0 0 2px 0',
                color: '#111827'
              }}>
                Konfirmasi Keuangan
              </h2>
              <p style={{ margin: 0, color: '#9ca3af', fontSize: 13 }}>
                {uangList.length} pengajuan keuangan menunggu persetujuan
              </p>
            </div>

            {/* Bulk Action Controls */}
            {uangList.length > 0 && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 20,
                padding: '16px',
                backgroundColor: '#f8fafc',
                borderRadius: 16,
                border: '1px solid #e2e8f0',
                gap: 16
              }}>
                <div
                  onClick={() => toggleSelectAll()}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 10, 
                    cursor: 'pointer',
                    userSelect: 'none',
                    alignSelf: 'flex-start'
                  }}
                >
                  <div style={{
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    border: `2px solid ${(uangList.length > 0 && selectedIds.length === uangList.length) ? '#2563eb' : '#cbd5e1'}`,
                    backgroundColor: (uangList.length > 0 && selectedIds.length === uangList.length) ? '#2563eb' : '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                  }}>
                    {(uangList.length > 0 && selectedIds.length === uangList.length) && (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    )}
                  </div>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#475569', whiteSpace: 'nowrap' }}>
                    Pilih Semua <span style={{ color: '#94a3b8', fontWeight: 500 }}>({selectedIds.length})</span>
                  </span>
                </div>

                {selectedIds.length > 0 && (
                  <div style={{ display: 'flex', gap: 12, width: '100%' }}>
                    <button
                      onClick={() => handleBulkKonfirmasiUang('ditolak')}
                      style={{
                        flex: 1,
                        padding: '10px 16px',
                        backgroundColor: '#fee2e2',
                        color: '#ef4444',
                        border: 'none',
                        borderRadius: 10,
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 6,
                        transition: 'background 0.2s'
                      }}
                    >
                      <span style={{ fontSize: 14 }}>✕</span> Tolak
                    </button>
                    <button
                      onClick={() => handleBulkKonfirmasiUang('disetujui')}
                      style={{
                        flex: 1,
                        padding: '10px 16px',
                        backgroundColor: '#10b981',
                        color: 'white',
                        border: 'none',
                        borderRadius: 10,
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 6,
                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.25)',
                        transition: 'opacity 0.2s'
                      }}
                    >
                      <span style={{ fontSize: 14 }}>✓</span> Terimakan
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Daftar Card */}
            <CardCarousel itemStyle={{ minWidth: 280, maxWidth: 340 }}>
              {uangList.map((item) => (
                <CardUangKonfirmasi
                  key={item.id}
                  item={item}
                  onSetujuClick={() => setSelectedItem(item)}
                  isSelected={selectedIds.includes(item.id)}
                  onToggle={toggleSelect}
                />
              ))}
            </CardCarousel>
            {/* Footer */}
            {/* <div style={{
              marginTop: 32,
              paddingTop: 20,
              borderTop: '1px solid #f0f0f0',
              textAlign: 'center',
              color: '#8c8c8c',
              fontSize: 13
            }}>
              <p style={{ margin: 0 }}>
                Klik area <span style={{ fontWeight: 500, color: '#1890ff' }}>"Berikan Persetujuan"</span> untuk memverifikasi setiap pengajuan
              </p>
            </div> */}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CardListUangKonfirmasi;
